import { Suspense } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet, useLocation } from 'react-router-dom';

import { queryClient } from '@/api/queryClient';
import { Loader } from '@/components/Loader';
import { Container } from '@/components/layout/Container';
import { ErrorBoundary } from '@/components/layout/ErrorBoundary';
import { Header } from '@/components/layout/Header';
import { KaiRail } from '@/components/layout/KaiRail';
import { Navigation } from '@/components/layout/Navigation';
import { CanvasRoutes, RouterConfig } from '@/configs/routes';
import { SidebarProvider } from '@/providers/SidebarApp';
import { TenantProvider } from '@/providers/TenantProvider';
import '@/styles/canvas.css';

export function Layout() {
  const location = useLocation();

  // Bonfire's dense admin tables put action buttons in the bottom-right, where the floating KAI button sits.
  const isKaiHidden = location.pathname.startsWith(RouterConfig[CanvasRoutes.Bonfire].path);

  const loader = (
    <Container>
      <Loader containerClass="w-full" message={'Loading Canvas application'} />
    </Container>
  );

  return (
    <ErrorBoundary locationKey={location.key} component="KSAI - Deep Enterprise">
      <QueryClientProvider client={queryClient}>
        <SidebarProvider>
          <Suspense fallback={loader}>
            <TenantProvider>
              <div className="w-full h-screen bg-[#F5F6F8] flex flex-col overflow-hidden">
                <Suspense fallback={loader}>
                  <Header />
                  <div className="flex flex-1 overflow-hidden">
                    <Navigation />
                    <ErrorBoundary locationKey={location.key} component="Layout">
                      <Suspense fallback={loader}>
                        <Outlet />
                      </Suspense>
                    </ErrorBoundary>
                    {!isKaiHidden && <KaiRail />}
                  </div>
                </Suspense>
                <div id="ksai-portal-root"></div>
              </div>
            </TenantProvider>
          </Suspense>
        </SidebarProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
